import React, { Component } from "react";
import withFirebaseAuth from "react-with-firebase-auth";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import firebaseConfig from "./firebaseConfig";
import Home from "./components/Home/Home";
// import logo from './logo.svg';
import "./App.css";
import App from "./App";
import Navbar from "./components/Navbar/Navbarplus";
import "./components/Navbar/Navbarplus.css";
const firebaseApp = firebase.initializeApp(firebaseConfig);

class Auth extends Component {
  render() {
    const { user, signOut, signInWithGoogle } = this.props;

    return (
      <div className="App">
        <header className="App-header">
          {user ? (
            <div>
              <nav className="navbar">
                <h1 className="navbar-title">WeekendMovs</h1>
                <nav className="navbar-menu">
                  <button type="button" className="navbutton">
                    <a href="/">Home</a>
                  </button>
                  <button type="button" className="navbutton">
                    <a href="https://www.linkedin.com/in/adittyapatil/" target="_blank">Contact</a>
                  </button>
                  <button type="button" className="navbutton">
                    MyList
                  </button>
                  {/* <button className="navbuttonlogout">Logout</button> */}
                  <button className="navbuttonlogout" onClick={signOut}>
                    Logout
                  </button>
                </nav>
              </nav>
              {/* <Navbar/> */}
              <Home />
            </div>
          ) : (
            <div className="welcomepage">
              <p className="text">Welcome To ,</p>
              <h1>WeekendMovs</h1>
              <button className="authButton" onClick={signInWithGoogle}>
                Sign In{" "}
              </button>
            </div>
          )}
        </header>
      </div>
    );
  }
}

const firebaseAppAuth = firebaseApp.auth();

const providers = {
  googleProvider: new firebase.auth.GoogleAuthProvider(),
};

export default withFirebaseAuth({
  providers,
  firebaseAppAuth,
})(Auth);
